import { useCallback, useState } from 'react';

/** State holding an incrementing integer, useful for manually invalidating hook dependencies. */
export const useGeneration = () => {
  const [generation, setGeneration] = useState(0);

  const bump = useCallback(() => setGeneration(it => it + 1), []);

  return [generation, bump] as const;
};
